module.exports = __webpack_public_path__ + "static/media/OverlappedCard_Mobile.21bf4a8a.svg";